import { Component, output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PhoneReportCreate, PhoneReportTestType } from '../../../shared/models/phone-report.model';
import { BrowserUtils } from '../../../shared/services/browser-utils';
import { DialogRef, ModalService } from '../../../shared/services/modal.service';
import { PhoneReportService } from '../../../shared/services/phone-report.service';

@Component({
  standalone: false,
  selector: 'app-phone-report-widget',
  templateUrl: './phone-reports-widget.component.html',
})
export class PhoneReportsWidgetComponent {
  model: PhoneReportCreate = {};
  @ViewChild('formModalTpl', { read: TemplateRef, static: false }) formModalTpl: TemplateRef<HTMLTemplateElement>;

  dialog: DialogRef;

  phoneReportCreate = output<PhoneReportCreate>();

  constructor(
    public modal: ModalService,
    public service: PhoneReportService,
    public router: Router
  ) {}

  open({ phone, testId, testType }: { phone: string; testId: number; testType: PhoneReportTestType }): Promise<DialogRef> {
    const model = this.service.createModel();
    model.phone = phone;
    model.testId = testId;
    model.testType = testType;

    this.model = model;
    return new Promise(resolve => {
      this.dialog = this.modal.alert().component(this.formModalTpl).open();
      resolve(this.dialog);
    });
  }

  onAfterSave(isSaved: boolean) {
    this.dialog.close();

    if (isSaved) {
      const url = `${BrowserUtils.getHostUrl()}/#/other/reported-numbers`;

      window.open(url, '_blank', 'noopener');

      this.phoneReportCreate.emit(this.model);
    }
  }
}
